import { jwtDecode } from 'jwt-decode';
import api from '../../utils/webcall';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../utils/token';

var UserProfile = (function () {
    // var username = "username";
    var userdata = 'userdata';
    // var auth_key = "cur_user_auth";
    var isAuthorized = 'is_authorized'

    var setIsAuthorized = (flag) => {
        window.sessionStorage.setItem(isAuthorized, flag);
    }

    // var userDetailsAvailable = () => {
    //     return isLoggedIn() && (window.sessionStorage.get(userdata) != undefined || window.sessionStorage.get(userdata) != null)
    // }

    var auth = async () => {
        try {
            const token = window.sessionStorage.getItem(ACCESS_TOKEN);
            if (token) {
                const decoded = jwtDecode(token);
                const tokenExpiration = decoded.exp;
                const now = Date.now() / 1000;

                if (tokenExpiration < now) {
                    return await refreshToken();
                } else {
                    setIsAuthorized(true);
                    return true;
                }
            }
            else {
                setIsAuthorized(false);
                return false;
            }
        }
        catch (error) {
            console.error('Auth error:', error);
            setIsAuthorized(false);
            return false;
        }
    };

    var refreshToken = async () => {
        const refreshToken = window.sessionStorage.getItem(REFRESH_TOKEN);
        if (!refreshToken) {
            setIsAuthorized(false);
            return false;
        }

        try {
            const res = await api.post('/auth/token/refresh/', {
                refresh: refreshToken,
            });
            if (res.status === 200) {
                window.sessionStorage.setItem(ACCESS_TOKEN, res.data.access);
                setIsAuthorized(true);
                return true;
            } else {
                setIsAuthorized(false);
                return false;
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
            setIsAuthorized(false);
            return false;
        }
    };

    const logout = () => {
        window.sessionStorage.removeItem(ACCESS_TOKEN);
        window.sessionStorage.removeItem(userdata);
        setIsAuthorized(false);
        window.location.reload();
    };
    
    var getName = function () {
        if(isLoggedIn()){
            let temp = JSON.parse(window.sessionStorage.getItem(userdata));
            if(temp === null) return "";
            return JSON.parse(window.sessionStorage.getItem(userdata))["first_name"];
        }
        return "";
        
    };

    // var setName = function (name) {
    //     let newname = _.camelCase(name);
    //     window.sessionStorage.setItem(username, newname);
    // };

    var setAuth = function(token, refresh){
        window.sessionStorage.setItem(ACCESS_TOKEN, token);
        window.sessionStorage.setItem(REFRESH_TOKEN, refresh);
    }

    var setUserData = function(data){
        window.sessionStorage.setItem(userdata, JSON.stringify(data));
    }

    var isLoggedIn = function(){
        let temp = window.sessionStorage.getItem(ACCESS_TOKEN);
        return !(temp === null || temp === undefined);
    }

    var getRole = function(){
        if(!isLoggedIn()){
            return '';
        }
        let temp = JSON.parse(window.sessionStorage.getItem(userdata));
        if(temp === null){
            return ''
        }
        temp = temp['role'];
        return (temp !== null && temp !== undefined) ? temp.toUpperCase() : '';
    }

    // The server sends `is_owner` and `is_manager` alongside the role, because
    // it is the server that decides. These read that answer where it is
    // present, and fall back to the role only for a session that signed in
    // before the field existed.
    var capability = function (field, fallback) {
        if (!isLoggedIn()) return false;
        let data = JSON.parse(window.sessionStorage.getItem(userdata));
        if (data === null) return false;
        if (typeof data[field] === 'boolean') return data[field];
        return fallback();
    }

    /**
     * Owners run the business. Only they see takings, margins and what people
     * are paid, and only they approve leave and advances.
     */
    var isOwner = function () {
        return capability('is_owner',
            () => getRole() === "OWNER" || getRole() === "SUPERUSER");
    }

    var isManager = function(){
        return capability('is_manager',
            () => ["MANAGER", "OWNER", "SUPERUSER"].includes(getRole()));
    }

    var verifySession = async () => {
        if (!isLoggedIn()) {
            return false;
        }

        try {
            // First check token validity
            if (!(await auth())) {
                return false;
            }

            // Then verify session with backend
            const response = await api.get('/auth/verify-session/');
            if (response.status !== 200) return false;

            // Refresh what this account is allowed to do while we are here.
            // Without this, someone made an owner - or no longer one - would
            // keep the old menu until they signed out and back in.
            const fresh = response.data?.user;
            if (fresh) {
                const stored = JSON.parse(
                    window.sessionStorage.getItem(userdata) || '{}');
                // Merged, not replaced: this response carries the capabilities
                // but not the person's name.
                setUserData({ ...stored, ...fresh });
            }
            return true;
        } catch (error) {
            console.error('Session verification error:', error);
            return false;
        }
    };

    return {
        getName: getName,
        setAuth: setAuth,
        setUserData: setUserData,
        isLoggedIn: isLoggedIn,
        isManager: isManager,
        isOwner: isOwner,
        getRole: getRole,
        isAuthorized: isAuthorized,
        logout: logout,
        auth: auth,
        verifySession: verifySession
    }

})();

export default UserProfile;